module.exports = __webpack_public_path__ + "img/logo.f5fca4a7.png";